import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
// notifications-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  setSelectMailHistoryId(store, payload) {
    store.commit('setSelectMailHistoryId', payload)
  },
  setSearchStartDateTime(store, payload) {
    store.commit('setSearchStartDateTime', payload)
  },
  setSearchEndDateTime(store, payload) {
    store.commit('setSearchEndDateTime', payload)
  },
  async setMailHistories(store, payload) {
    store.state.mailHistories = []
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        displayDateTime: {
          startDateTime: payload.startDateTime,
          endDateTime: payload.endDateTime
        },
        pageNo: payload.pageNo,
        count: 20,
        searchWord: payload.searchWord
      }
    }
    const response = await Vue.http.post(
      URL + '/v2/master/mail/list',
      data,
      config
    )

    // 成功後の処理
    store.commit('setMailHistories', response)
  },
  async setMailHistoriesDetail(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        mailId: payload.mailHistoryId,
        result: payload.result
      }
    }
    const response = await Vue.http.post(
      URL + '/v2/master/mail/detail',
      data,
      config
    )

    // 成功後の処理
    store.commit('setMailHistoriesDetail', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/mailHistoryModules/actions.js